import { z } from 'zod'
import { oc } from '@orpc/contract'
import { copayStatusSchema, patientInvoiceKindSchema } from './copay-status.contract'

// Full refunds only in the current phase; partial refunds made directly in the
// Stripe dashboard are logged by the webhook but never change our status.
export const refundCopay = oc
  .route({ method: 'POST', path: '/v2/copay/{encounterId}/refund' })
  .input(
    z.object({ encounterId: z.string().min(1), kind: patientInvoiceKindSchema.default('copay') }),
  )
  .output(copayStatusSchema)
